
<v-row class="no-frame">
    <v-col class="no-frame v-col-3">
        <v-btn
            class    = "w-100 rating-button"
            :height  = "btnHeight"
            :class   = "yesClass"
            :ripple  = "false"
            :elevation = "0"
            variant  = "outlined"
            @click   = "onYes"
        >
            Ja
        </v-btn>
    </v-col>

    <v-col class="no-frame v-col-3 pl-2">
        <v-btn
            v-if     = "showNo"
            class    = "w-100 rating-button"
            :height  = "btnHeight"
            :class   = "noClass"
            :ripple  = "false"
            :elevation = "0"
            variant  = "outlined"
            @click   = "onNo"
        >
            Nein
        </v-btn>
    </v-col>


    <v-col class="no-frame v-col-3 pl-2" v-if="inadequate" >
        <v-btn
            class    = "w-100 rating-button"
            :height  = "btnHeight"
            :class   = "inClass"
            :elevation = "0"
            variant  = "outlined"
            @click   = "onInadequate"
        >
            Unzulänglich
        </v-btn>
    </v-col>
    <v-col class="no-frame v-col-3 pl-2">
        <v-btn
            class    = "w-100 rating-button"
            :height  = "btnHeight"
            :class   = "naClass"
            :elevation = "0"
            variant  = "outlined"
            @click   = "onNotApplicable"
        >
            nicht zutreffend
        </v-btn>
    </v-col>
</v-row>
